var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 277.54 70.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-width:0px;}.cls-2{isolation:isolate;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_67"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_4",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m53.74,41.71h9.8v11.74h-9.8v15.04h-13.87v-15.04H0v-.29L28.03,0h25.7v41.71ZM39.77,4.85l-18.62,36.86h18.72V4.85h-.1Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m177.11,35.7c12.89-5.68,21.32-14.2,21.77-23.65,0,0-3.4-2.62-14.4-6.67-5.5-2.07-11.2-3.54-17.02-4.36l.03,21.06c-.09,3.4-1.39,6.66-3.65,9.2-7.8-1.85-15.8-2.77-23.82-2.75h0c-8.03-.02-16.03.91-23.84,2.76-2.26-2.54-3.56-5.8-3.65-9.21l.03-21.06c-5.81.83-11.52,2.29-17.02,4.36-10.99,4.04-14.39,6.67-14.39,6.67.46,9.45,8.88,17.98,21.79,23.65-12.9,5.67-21.32,14.19-21.77,23.64,0,0,3.4,2.63,14.39,6.67,5.5,2.07,11.2,3.54,17.02,4.36l-.03-21.06c.09-3.4,1.39-6.66,3.65-9.2,7.8,1.85,15.8,2.77,23.81,2.75h0c8.03.02,16.03-.9,23.84-2.76,2.26,2.54,3.55,5.81,3.65,9.21l-.03,21.06c5.82-.83,11.53-2.29,17.02-4.37,10.99-4.04,14.39-6.67,14.39-6.67-.46-9.45-8.88-17.98-21.79-23.64m-37.08,4.74h-.25c-7.64,0-13.86-1.88-18.43-4.73,4.57-2.86,10.79-4.74,18.44-4.74h.49c7.64,0,13.86,1.87,18.43,4.73-4.57,2.86-10.79,4.74-18.44,4.74"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_4-2",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m267.74,41.71h9.8v11.74h-9.8v15.04h-13.87v-15.04h-39.87v-.29L242.03,0h25.7v41.71Zm-13.97-36.86l-18.62,36.86h18.72V4.85h-.1Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.ceea17a64a0adf82c41816e4cf3b86d3.svg";
export { ForwardRef as ReactComponent };